module.exports = __webpack_public_path__ + "img/EJE_BASICO.567e9ab2.png";